module.exports = require('./lib/linkify-string').default;



//////////////////
// WEBPACK FOOTER
// ./~/linkifyjs/string.js
// module id = 581
// module chunks = 1